import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import type { Waypoint } from '../types';

interface Props {
  waypoints: Waypoint[];
}

export default function RouteNodeList({ waypoints }: Props) {
  if (waypoints.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ p: 2, textAlign: 'center' }}>
        No waypoints
      </Typography>
    );
  }

  return (
    <Box data-testid="route-node-list">
      <List dense disablePadding>
        {waypoints.map((wp, i) => (
          <ListItem key={wp.index} sx={{ px: 2, py: 0.5 }}>
            <ListItemText
              primary={
                <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
                  <Typography variant="body2" color="text.secondary" sx={{ minWidth: 24 }}>
                    {i + 1}.
                  </Typography>
                  <Typography variant="body2" sx={{ fontFamily: 'monospace' }}>
                    {wp.lat.toFixed(4)}, {wp.lon.toFixed(4)}
                  </Typography>
                  {wp.name && (
                    <Typography variant="caption" color="text.secondary">
                      {wp.name}
                    </Typography>
                  )}
                </Box>
              }
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
}
